/* eslint-disable max-len */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { dataService } from '../../../services/data.services';
import InfiniteScroll from 'react-infinite-scroll-component';

const CityDropdown = ({
    selectedFilter,
    buttonDisabled,
    cityList,
    handleCityOptionClick,
    handleCityDropdownClose,
    setCityDropdownIsOpen,
    handleClearFilter,
    GraphKey,
    cityDropdownisOpen,
    totalCity
}) => {

    const [searchTerm, setSearchTerm] = useState('');
    const [apiTerm,setTermApi] = useState('')
    const [searchData, setSearchData] = useState([])
    const [originalCityData, setOriginalCityData] = useState([]); // New state variable for the original list
    const [showClearIcon, setShowClearIcon] = useState(false);
    const [defaultCount, setDefaultCount] = useState()
    const [cityPage, setCityPage] = useState(1)
    const [debounceTimer,setDebounceTimer] = useState(null)

    const dropdownRef = useRef(null);

    // let debounceTimer;

    const handleSearch = async (value,pageNumber,key) => {
        try {
            const searchValue = encodeURIComponent(value)
            const response = await dataService.GetAPI(`merchant-users/list?city_search=true&city_list=true&search=${searchValue}&page_number=${pageNumber}`);
            // setSearchData(response?.data?.data);
            if (key) {
                setSearchData(response?.data?.data);
            } else {
                setSearchData(prevData => [...prevData, ...response?.data?.data]);
            }
            setDefaultCount(response?.data?.total_count)
            console.log(response?.data?.data)
        } catch {
            console.error('An error occurred while fetching data:', error);
        }
    }
    const handleChange = (e) => {
        const { value } = e.target;
        setSearchTerm(value);
        setShowClearIcon(value !== '');
        setCityPage(1)
        setSearchData([])
        // Reset page number when search term changes
        // setPageNumber(1);

        // Clear the previous timer if it exists
        clearTimeout(debounceTimer);

        // Set a new timer to call handleSearch after 500ms
        const timer = setTimeout(() => {
            handleSearch(value, 1,'search'); // Always start from page 1 when the search term changes
        }, 500);
        setDebounceTimer(timer)
    };


    // this function is for clear the search items inside the dropdown
    const handleClear = () => {
        setSearchTerm('');
        setShowClearIcon(false);
        setSearchData(originalCityData);
        setDefaultCount(totalCity)
        setCityPage(1)
        // setPageNumber(1); // Reset page number when search term is cleared
    };

    // const handleDocumentClick = (event) => {
    //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //         // Clicked outside the dropdown
    //         setCityDropdownIsOpen(false);
    //     }
    // };

    // useEffect(() => {
    //     document.addEventListener('mousedown', handleDocumentClick);
    //     return () => {
    //         document.removeEventListener('mousedown', handleDocumentClick);
    //     };
    // }, []);
    // Add a new function to handle closing the dropdown
    const updatePage = () => {
        const page = cityPage+1
        setCityPage(page) 
        handleSearch(searchTerm,page);
    }

    useEffect(() => {
        setSearchData(cityList);
        setOriginalCityData(cityList);
        setDefaultCount(totalCity)
    }, [cityList]);

    return (
        <div>
            <div className="relative inline-block max-w-[165px] w-[133px] ml-5 h-9">
                <button
                    data-testid={`city-dropdown-${GraphKey}`}
                    onClick={() => setCityDropdownIsOpen(!cityDropdownisOpen)} // Toggle the cityDropdownisOpen state
                    style={{
                        width: '-webkit-fill-available',
                        backgroundColor: buttonDisabled ? '#DDDDDD' : 'transparent', // Conditionally set background color
                        cursor: buttonDisabled ? 'not-allowed' : 'pointer'
                    }}
                    disabled={buttonDisabled}
                    title={selectedFilter === null ? 'Select City' : selectedFilter}
                    className={`flex items-center w-full justify-between px-[9px] py-2 border-2 border-[#CDCDCD] rounded-md font-normal text-xs text-black relative pr-8 ${selectedFilter !== null ? 'truncate' : ''}`}
                >
                    <p className='truncate'>
                        {cityDropdownisOpen ? (selectedFilter || 'Select City') : (selectedFilter || 'City')}
                    </p>
                    <img
                        className={`ml-2 h-4 w-7 transition-transform duration-300 transform absolute top-[7px] right-0 ${cityDropdownisOpen ? 'rotate-180' : ''}`}
                        src="/assets/images/Black-down-arrow.svg"
                        alt="Arrow"
                        onClick={() => setCityDropdownIsOpen(!cityDropdownisOpen)} />
                </button>
                {cityDropdownisOpen && (
                    <div ref={dropdownRef} className="absolute z-10 w-full bg-white shadow-lg rounded-md pr-1">
                        <div className='h-max-auto h-auto overflow-auto scrollBar pr-1'>
                            <div className="flex items-center justify-between p-2 border border-[#CDCDCD] rounded relative bg-white  top-0">
                                <input
                                    type="text"
                                    // style={{ width: '-webkit-fill-available' }}
                                    className="flex-grow w-full pl-3 pr-7 py-[5px] border border-[#CDCDCD] text-xs font-normal text-black rounded-md  outline-0 placeholder:text-xs placeholder:text-[#52555D] placeholder:font-normal"
                                    placeholder="Search"
                                    value={searchTerm}
                                    data-testid="search"
                                    onChange={handleChange}
                                />
                                {showClearIcon ? (
                                    <button data-testid="clear-btn" onClick={handleClear} className="absolute right-[18px] top-[50%] transform -translate-y-1/2">
                                        <img src="/assets/images/close-icon.svg" alt='Clear' />
                                    </button>
                                ) : (
                                    <img src="/assets/images/search-gray.svg" alt='' className='absolute right-[18px] top-[16px]' />
                                )}
                            </div>
                            {selectedFilter !== 'All Cities' && (
                                <button
                                    className='text-black py-2 px-[9px] text-sm font-medium text-left border border-[#CDCDCD] rounded w-full'
                                    data-testid="select-all"
                                    onClick={() => {
                                        handleClearFilter(GraphKey, 'city'),
                                        handleCityDropdownClose(); // Close the dropdown
                                    }}
                                >
                                    All Cities
                                </button>
                            )}
                            {/* {[...new Set(searchData.filter(item => item.city).map(item => item.city))].map(city => (
                                <button
                                    title={city}
                                    key={city} // Using city name as key
                                    onClick={() => {
                                        handleCityOptionClick(city, "city");
                                        handleCityDropdownClose(); // Close the dropdown
                                    }}
                                    className="block w-full px-[9px] py-2 capitalize text-left hover:bg-[#EB9DC7] focus:outline-none border border-[#CDCDCD] rounded font-normal text-xs text-black truncate"
                                >
                                    {city}
                                </button>
                            ))} */}
                            <InfiniteScroll
                                dataLength={searchData?.length}
                                pageStart={1}
                                //calculating dropdown height based number of records,max height 162px
                                height={searchData?.length > 4 ? '162' : searchData?.length * 34} 
                                className='scrollBar max-h-[162px]'
                                next={() => updatePage()}
                                hasMore={Math.ceil(defaultCount / 10) === cityPage ? false : true}
                                useWindow={false}>
                                {[...new Set(searchData.filter(item => item.city).map(item => item.city))].map((city, index) => (

                                    <button
                                        title={city}
                                        key={city} // Using city name as key
                                        onClick={() => {
                                            handleCityOptionClick(city, "city");
                                            handleCityDropdownClose(); // Close the dropdown
                                        }}
                                        data-testid={`${GraphKey}-${index}`}
                                        className="block w-full px-[9px] py-2 capitalize text-left hover:bg-[#EB9DC7] focus:outline-none border border-[#CDCDCD] rounded font-normal text-xs text-black truncate"
                                    >
                                        {city}
                                    </button>
                                ))}
                            </InfiniteScroll>
                        </div>
                    </div>
                )}
            </div>
        </div >
    );
};

export default CityDropdown;
